import React from 'react';
import UserProfileForm from './components/profile-form';

const EditUserProfile = ({setUserInfoModal=() => {}, isOpenUserInfoModal=false}) => {

  return (
    <>
     <UserProfileForm isPage={true} setUserInfoModal={setUserInfoModal} isOpenUserInfoModal={isOpenUserInfoModal} />
    </>
  )
}

export default EditUserProfile